import { maxLength, required } from 'vuelidate/lib/validators';
import {
  ADHOC_EQUIPMENT_MAX_LENGTH,
  EXTERIOR_COLOUR_MAX_LENGTH,
  INTERIOR_COLOUR_MAX_LENGTH,
  TEMP_ADHOC_EQUIPMENT_MAX_LENGTH
} from '@/utils/constants';

export default {
  selectedExteriorColour: { required, maxLength: maxLength(EXTERIOR_COLOUR_MAX_LENGTH) },
  selectedInteriorColour: { required, maxLength: maxLength(INTERIOR_COLOUR_MAX_LENGTH) },
  customerOptions: {
    adhocEquipment: {
      $each: {
        required,
        maxLength: maxLength(ADHOC_EQUIPMENT_MAX_LENGTH)
      }
    }
  },
  tempAdhocEquipment: {
    maxLength: maxLength(TEMP_ADHOC_EQUIPMENT_MAX_LENGTH)
  }
};
